export enum LinkTypes {
  COOKIE_MANAGEMENT_LINK = 'cookie_management_link',
  HREF = 'href_link',
  NAVIGATION = 'navigation_link',
  MODAL = 'modal_link',
  SCROLL = 'scroll_link',
}
